import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import { CirclePicker } from 'react-color'

export default ({ open, colour, onSave = () => {}, onClose = () => {} }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent style={{ minHeight: 150 }}>
        <CirclePicker
          color={colour}
          onChangeComplete={newColour => onSave(newColour)}
        />
      </DialogContent>
      <DialogActions>
        <Button color='secondary' onClick={onSave}>
          Clear
        </Button>
        <Button color='primary' onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}
